import { clearSection, clearSubSection }                  from 'dmpconnectjsapp-base/actions';
import { formatGetMssHpInfosParams }                      from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import commands, { mssSubTypes }                          from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections, mssLoginTypes }                     from 'dmpconnectjsapp-base/constants';
import { getError, hasError, isLoading, isReady }         from 'dmpconnectjsapp-base/helpers/common';
import { getAccessRightsProps }                           from 'dmpconnectjsapp-base/rules/accessRights';
import PropTypes                                          from 'prop-types';
import React                                              from 'react';
import { Form }                                           from 'react-bootstrap';
import { connect }                                        from 'react-redux';
import { addMssAccount, getAction, setMssAccountActive }  from '../../dmpconnect/actions';
import { getConfigFromAutoConfigResult, mssAccountTypes } from '../../dmpconnect/helpers/mss';
import { generateUniqueId, isEmailValid }                 from '../../dmpconnect/utils/dataUtils';
import env                                                from '../../envVariables';
import ButtonWithLoader                                   from '../Common/Form/ButtonWithLoader';
import CustomCheckbox                                     from '../Common/Form/Input/CustomCheckbox';
import ToggleCheckboxes                                   from '../Common/Form/Input/ToggleCheckboxes';
import Loading                                            from '../Common/Loading/Loading';
import ErrorMessage                                       from '../Common/Message/ErrorMessage';

MssAutoConfigForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  hpId    : PropTypes.string.isRequired,
};

function MssAutoConfigForm ({ callback, dispatch, autoConfigSection, psId, hpId, getHpSection }) {
  const [email, setEmail] = React.useState('');
  const [type, setType]   = React.useState(mssAccountTypes.PER_ORG);
  
  const addresses = React.useMemo(() => {
    if (isReady(getHpSection)) {
      const recipients = getHpSection.PSList;
      if (!recipients) {
        return [];
      }
      
      return [
        ...new Map(recipients.map(
          ({
            s_mail, ...rest
          }) => [
            s_mail, {
              s_mail, ...rest,
            },
          ],
        )).values(),
      ];
    }
    return [];
  }, [getHpSection]);
  
  React.useEffect(() => {
    if (addresses.length === 1) {
      setEmail(addresses[0].s_mail);
    }
  }, [addresses])
  
  React.useEffect(() => {
    dispatch(clearSection(apiSections.MSS_GET_AUTO_CONFIG));
    
    dispatch(getAction(
      commands.getMssHpInfos,
      apiSections.MSS_GET_HP_INFOS,
      formatGetMssHpInfosParams(
        undefined,
        undefined,
        hpId,
      ),
      {
        subSection: hpId,
        silentError: true,
      },
    ));
    
    return () => {
      dispatch(clearSection(apiSections.MSS_GET_AUTO_CONFIG));
      dispatch(clearSubSection(apiSections.MSS_GET_HP_INFOS, hpId));
    };
  }, []);
  
  const section = React.useMemo(() => {
    return autoConfigSection[email] || {};
  }, [email, autoConfigSection]);
  
  React.useEffect(() => {
    if (isReady(section) && (section.Configurations || []).length > 0) {
      
      const config  = getConfigFromAutoConfigResult(section, type);
      const account = {
        autoConfigured: true,
        id            : generateUniqueId(),
        mssOperator   : 'custom',
        mssEmail      : email,
        mssApiType    : mssSubTypes.IMAP,
        mssLoginType  : type === mssAccountTypes.PER_ORG ? mssLoginTypes.PSC : mssLoginTypes.CERT,
        ...config,
      };
      dispatch(addMssAccount(psId, account));
      dispatch(setMssAccountActive(psId, account));
      callback();
    }
  }, [section, psId, type]);
  
  const getAutoConfig = React.useCallback((mail) => {
    dispatch(getAction(
      commands.getMssAutoconfigurationFromDns,
      apiSections.MSS_GET_AUTO_CONFIG,
      mail,
      {
        subSection: mail,
      },
    ));
  }, []);
  
  return (
    <>
      {hasError(section) && (
        <ErrorMessage error={getError(section)}/>
      )}
      {(isReady(section) && section.Configurations.length === 0) && (
        <ErrorMessage title="Auto Configuration MSSanté" message="Aucune configuration n'a été trouvé."/>
      )}
      
      <Form.Group>
        <Form.Label>Adresses trouvées dans l'annuaire :</Form.Label>
        {isLoading(getHpSection) && <Loading size="sm" />}
        {addresses && addresses.length > 0 && !isLoading(getHpSection) ? (
          <ToggleCheckboxes
            type="radio"
            onChange={mail => setEmail(mail)}
            items={addresses.map(address => ({ label: address.s_mail, value: address.s_mail, id: address.s_mail }))}
            checked={email}
            className="vertical"
          />
        ) : 'Aucune adresse trouvée dans l\'annuaire'}
      </Form.Group>
      <Form.Group id="autoConfigMssEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control
          className="w-full"
          onChange={event => setEmail(event.target.value)}
          name="autoConfigMssEmail"
          value={email}
          isInvalid={!isEmailValid(email)}
        />
        {!email && <Form.Control.Feedback type="invalid">Ce champs est requis</Form.Control.Feedback>}
        {!!email && !isEmailValid(email) && (
          <Form.Control.Feedback type="invalid">Adresse email invalide</Form.Control.Feedback>
        )}
      </Form.Group>
      {Number(env.REACT_APP_DEBUG) === 1 && (
        <Form.Group>
          <CustomCheckbox
            type="radio"
            id="auto-config-mss-per"
            label="Boite personnelle / organisationnelle"
            value={String(mssAccountTypes.PER_ORG)}
            checked={type === mssAccountTypes.PER_ORG}
            name="autoConfigType"
            onChange={() => setType(mssAccountTypes.PER_ORG)}
          />
          <CustomCheckbox
            type="radio"
            id="auto-config-mss-app"
            label="Boite applicative"
            value={String(mssAccountTypes.AUTH_CLI)}
            checked={type === mssAccountTypes.AUTH_CLI}
            name="autoConfigType"
            onChange={() => setType(mssAccountTypes.AUTH_CLI)}
          />
        </Form.Group>
      )}
      <Form.Group>
        <ButtonWithLoader
          onClick={() => getAutoConfig(email)}
          label="Configurer la BAL"
          loading={isLoading(section)}
          loadingLabel="Configurer la BAL"
        />
      </Form.Group>
    </>
  );
}

function mapStateToProps (state) {
  const { accessRights: { psId, hpId } } = getAccessRightsProps(state);
  const {
          dmpconnect: {
            [apiSections.MSS_GET_AUTO_CONFIG]: autoConfigSection,
            [apiSections.MSS_GET_HP_INFOS]   : {
              [hpId]: getHpSection,
            } = {},
          },
        }                          = state;
  return {
    autoConfigSection,
    getHpSection,
    hpId,
    psId
  };
}

export default connect(mapStateToProps)(MssAutoConfigForm);